import React, { Component } from 'react';

export const TableHeadItem = ({dayWeek, date}) => (
    <th className="appointment_table__head">
        <p>{dayWeek}</p>
        <p>{date}</p>
    </th>
)

export default TableHeadItem;


// WEBPACK FOOTER //
// frontend/src/modules/appointment-table/TableHeadItem.jsx